import { render, staticRenderFns } from "./ClientList.vue?vue&type=template&id=0a251866&scoped=true"
import script from "./ClientList.vue?vue&type=script&lang=js"
export * from "./ClientList.vue?vue&type=script&lang=js"
import style0 from "./ClientList.vue?vue&type=style&index=0&id=0a251866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a251866",
  null
  
)

export default component.exports